import React from 'react';
import confirmRouteIcon from '../../assets/svgs/confirmRoute.svg';

interface RoutePanelProps {
  routeStatus?: string;
  originPadLabel?: string;
  destinationPadLabel?: string;
  className?: string;
  style?: React.CSSProperties;
  onOriginPadClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onDestinationPadClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const getStatusPillClasses = (status?: string) => {
  const normalized = (status || '').toUpperCase();
  // Match colours from OrderCard.tsx MISSION_STATUS mapping
  if (normalized === 'PROPOSED' || normalized === 'PENDING') return 'bg-orange-100 text-orange-800';
  if (normalized === 'HOLD') return 'bg-green-100 text-green-800';
  if (normalized === 'IN_PROGRESS') return 'bg-red-100 text-red-800';
  if (normalized === 'COMPLETED') return 'bg-gray-100 text-gray-800';
  if (normalized === 'MANUAL' || normalized === 'ABORTED') return 'bg-red-100 text-red-800';
  return 'bg-gray-100 text-gray-700';
};

export const RoutePanel: React.FC<RoutePanelProps> = ({
  routeStatus,
  originPadLabel,
  destinationPadLabel,
  className = '',
  style = {},
  onOriginPadClick,
  onDestinationPadClick
}) => {
  const originClickable = !!onOriginPadClick;
  const destinationClickable = !!onDestinationPadClick;

  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-3 ${className}`} style={style}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-700">
            <img src={confirmRouteIcon} alt="Route" className="w-5 h-5" />
          </div>
          <div className="text-sm font-semibold text-gray-900">Route</div>
        </div>
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusPillClasses(routeStatus)}`}>
          {routeStatus || '—'}
        </span>
      </div>
      <div className="mt-3 flex items-center gap-3">
        <div className="flex-1">
          <div 
            className={`px-4 py-2 text-sm border border-gray-300 rounded-md bg-white truncate ${
              originClickable ? 'cursor-pointer hover:bg-gray-50 hover:border-gray-400' : ''
            } ${originPadLabel ? 'text-gray-900' : 'text-gray-400'}`}
            title={`${originPadLabel || 'Pad...'}`}
            onClick={originClickable ? onOriginPadClick : undefined}
          >
            {originPadLabel || 'Pad...'}
          </div>
        </div>
        <div className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center text-gray-700">➜</div>
        <div className="flex-1">
          <div 
            className={`px-4 py-2 text-sm border border-gray-300 rounded-md bg-white truncate ${
              destinationClickable ? 'cursor-pointer hover:bg-gray-50 hover:border-gray-400' : ''
            } ${destinationPadLabel ? 'text-gray-900' : 'text-gray-400'}`}
            title={`${destinationPadLabel || 'Pad...'}`}
            onClick={destinationClickable ? onDestinationPadClick : undefined}
          >
            {destinationPadLabel || 'Pad...'}
          </div>
        </div>
      </div>
    </div>
  );
};

